var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 7.75C23.7761 7.75 24 7.97388 24 8.25V20.25C24 20.913 23.7366 21.549 23.2678 22.0178C22.7989 22.4866 22.163 22.75 21.5 22.75H2.5C1.11929 22.75 0 21.6307 0 20.25V8.25C0 7.97388 0.223854 7.75 0.5 7.75H23.5ZM16.9984 15.25C16.9984 14.7524 16.6964 14.3045 16.235 14.118L9.609 11.342C9.25662 11.1891 8.85119 11.222 8.52812 11.4299C8.20506 11.6377 8.00697 11.993 8 12.377V18.123C8.00746 18.5069 8.20566 18.8618 8.52856 19.0695C8.85146 19.2772 9.2566 19.3104 9.609 19.158L16.235 16.382C16.6964 16.1955 16.9984 15.7477 16.9984 15.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.563 1.677C19.6346 1.60562 19.6561 1.49818 19.6176 1.40473C19.5791 1.31128 19.4881 1.25022 19.387 1.25H15.6C15.5727 1.25023 15.5466 1.26098 15.527 1.28L10.987 5.823C10.9153 5.89451 10.8938 6.00219 10.9326 6.09573C10.9714 6.18927 11.0627 6.25018 11.164 6.25H14.947C14.9746 6.24992 15.0011 6.23917 15.021 6.22L19.563 1.677Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.075 1.318C22.0588 1.31402 22.0416 1.31897 22.03 1.331L17.538 5.823C17.4663 5.89451 17.4448 6.0022 17.4836 6.09573C17.5224 6.18927 17.6137 6.25018 17.715 6.25H23.5C23.7761 6.25 24 6.02615 24 5.75V3.75C23.9995 2.59116 23.2028 1.58454 22.075 1.318Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.013 1.677C13.0847 1.60549 13.1062 1.49781 13.0674 1.40427C13.0286 1.31073 12.9373 1.24982 12.836 1.25H9.1C9.07271 1.25023 9.04656 1.26098 9.027 1.28L4.487 5.823C4.41531 5.89451 4.39383 6.0022 4.43261 6.09573C4.47138 6.18927 4.56274 6.25018 4.664 6.25H8.4C8.42729 6.24977 8.45343 6.23902 8.473 6.22L13.013 1.677Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.513 1.677C6.58469 1.60549 6.60617 1.49781 6.56739 1.40427C6.52862 1.31073 6.43725 1.24982 6.336 1.25H2.5C1.11929 1.25 0 2.36929 0 3.75V5.75C0 6.02614 0.223858 6.25 0.5 6.25H1.9C1.92729 6.24977 1.95344 6.23902 1.973 6.22L6.513 1.677Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayer);
export default __webpack_public_path__ + "static/media/videoPlayer.66075146.svg";
export { ForwardRef as ReactComponent };